export const ProductTypeNameToId = {
  MW: 1,
  SP: 2,
  FP: 3,
  VS: 4,
  VM: 5,
  PW: 6
}

export const ProductTypeId = {
  [ProductTypeNameToId.MW]: { name: 'マイウィーク', nameEn: 'MY WEEK', newBookingName: 'デイプラン' },
  [ProductTypeNameToId.SP]: { name: 'シェアリングポイント', nameEn: 'SHARING POINT', newBookingName: 'シェアリングポイント' },
  [ProductTypeNameToId.FP]: { name: 'フレックスポイント', nameEn: 'FLEX POINT', newBookingName: 'フレックスポイント' },
  [ProductTypeNameToId.VS]: { name: 'バケーションスタイル', nameEn: 'VACATION STYLE', newBookingName: 'バケーションスタイル' },
  [ProductTypeNameToId.VM]: { name: 'バケーションマスター', nameEn: 'VACATION MASTER', newBookingName: 'マスターズオプション' },
  [ProductTypeNameToId.PW]: { name: 'プライムウィーク', nameEn: 'PRIME WEEK', newBookingName: '' }
}

export const ProductTypeIdToPlanType = {
  [ProductTypeNameToId.SP]: 'SP',
  [ProductTypeNameToId.FP]: 'FP',
  [ProductTypeNameToId.VS]: 'VS',
  [ProductTypeNameToId.VM]: 'MO'
}

export function getNameOfProduct (productTypeId) {
  return ProductTypeId[productTypeId].name
}

export function contractIsForNewBooking (productTypeId) {
  productTypeId = parseInt(productTypeId, 10)
  return !!(getNewBookingName(productTypeId))
}

export function getNewBookingName (productTypeId) {
  return ProductTypeId[productTypeId] && ProductTypeId[productTypeId].newBookingName
}

export function getNewBookingContractName (contract) {
  const productTypeId = parseInt(contract.productType.id, 10)
  const contractName = `${getNewBookingName(productTypeId)} (${contract.contractNumber})`

  if (productTypeId !== ProductTypeNameToId.VM) return contractName

  const facility = contract.vmRoomType && contract.vmRoomType.facility
  const facilityName = facility && (facility.nameAbbr || facility.name)
  const agreedTerminationDate = contract.agreedTerminationDate &&
    contract.agreedTerminationDate
      .split('-')
      .slice(0, 3)
      .map((part, index) => index === 0 ? part : part.padStart(2, '0'))

  return [
    contractName,
    facilityName,
    agreedTerminationDate && agreedTerminationDate.length === 3
      ? `合意解約日 (${agreedTerminationDate[0]}年${agreedTerminationDate[1]}月${agreedTerminationDate[2]}日)`
      : null,
  ].filter(Boolean).join(' ')
}

export function isPointBasedProduct (productTypeId) {
  return productTypeId === ProductTypeNameToId.SP || productTypeId === ProductTypeNameToId.FP
}

export function canUseTvpForNewBooking (productTypeId) {
  return productTypeId === ProductTypeNameToId.VS || productTypeId === ProductTypeNameToId.VM
}
